import React from 'react';
import {
    Add as AddIcon,
    StickyNote2Outlined as NotesIcon,
    HistoryEduOutlined as AnamnesisIcon,
    StraightenOutlined as MeasuresIcon
} from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import CustomButton from '../../../components/buttons/CustomButton';
import styles from './AppointmentTypesEmptyState.module.css';

/** Motivo no tooltip de "Adicionar tipo" para quem não é proprietário nem administrador. */
export const ADD_DENIED = 'Apenas proprietários e administradores podem adicionar tipos de atendimento';

const SAMPLE = [
    { key: 'notes', icon: <NotesIcon />, label: 'Anotações' },
    { key: 'anamnesis', icon: <AnamnesisIcon />, label: 'Anamnese' },
    { key: 'measures', icon: <MeasuresIcon />, label: 'Medidas' }
];

/** Nenhum tipo ainda: maquete de um tipo com três módulos e o atalho para criar o primeiro. */
function AppointmentTypesEmptyState({ onAdd, canManage = true }) {
    return (
        <div className={styles.empty}>
            <div className={styles.art} aria-hidden="true">
                <div className={styles.mock}>
                    <span className={styles.mockTitle} />
                    {SAMPLE.map((item, index) => (
                        <span key={item.key} className={styles.mockModule}>
                            <span className={styles.mockIndex}>{index + 1}</span>
                            <span className={styles.mockIcon}>{item.icon}</span>
                            {item.label}
                        </span>
                    ))}
                </div>
            </div>
            <span className={styles.title}>Nenhum tipo de atendimento cadastrado</span>
            <span className={styles.text}>
                Crie um tipo para cada forma de atender e escolha quais cards aparecem, na ordem que preferir.
            </span>
            <div className={styles.action}>
                <Tooltip title={!canManage ? ADD_DENIED : ''} arrow>
                    <span>
                        <CustomButton
                            style="main"
                            variant="contained"
                            icon={<AddIcon />}
                            label="Adicionar tipo"
                            onClick={onAdd}
                            enabled={canManage}
                        />
                    </span>
                </Tooltip>
            </div>
        </div>
    );
}

export default AppointmentTypesEmptyState;
